export interface CapacitorScrollSwipeBounceIosPlugin {
  echo(options: { value: string }): Promise<{ value: string }>;
}
